var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Thank you for visiting RateRabbit Administration.")]),_c('br'),_c('h1',[_vm._v("You have been logged out!")])])
}]

export { render, staticRenderFns }